import { config as base } from '@giscube/geoportal';
export default base.merge({
  basemaps: [{
    default: false,
    type: 'tilelayer',
    name: 'Blanc',
    url: ''
  }, {
    default: false,
    type: 'tilelayer',
    name: 'Topogràfic Aj. Figueres (transparent)',
    url: 'https://parcsjardins.microdisseny.com/cartobase/topografic-transparent/{z}/{x}/{y}{r}.png',
    attribution: '&copy; <a href="https://www.figueres.cat" target="_blank">Ajuntament de Figueres</a>',
    maxNativeZoom: 22,
    maxZoom: 23,
    detectRetina: false,
    bounds: [[42.237, 2.927], [42.292, 3.03]]
  }, // {
  //   default: false,
  //   type: 'tilelayer',
  //   name: 'Topogràfic Aj. Figueres (no retina)',
  //   url: 'https://parcsjardins.figueres.org/cartobase/topografic-transparent/{z}/{x}/{y}.png',
  //   attribution: '&copy; <a href="https://www.figueres.cat" target="_blank">Ajuntament de Figueres</a>',
  //   maxNativeZoom: 22,
  //   maxZoom: 23,
  //   detectRetina: false,
  //   bounds: [
  //     [42.237, 2.927],
  //     [42.292, 3.03]
  //   ]
  // },
  {
    default: true,
    type: 'tilelayer',
    name: 'Ortofoto 2020 Aj. Figueres',
    url: 'https://parcsjardins.microdisseny.com/apps/giscube-admin/imageserver/services/ortofoto-2020/tilecache/{z}/{x}/{y}.jpg',
    attribution: '&copy; <a href="https://www.figueres.cat" target="_blank">Ajuntament de Figueres</a>',
    maxNativeZoom: 22,
    maxZoom: 23,
    detectRetina: false,
    bounds: [[42.236, 2.927], [42.293, 3.031]]
  }, {
    default: false,
    type: 'tilelayer',
    name: 'Ortoxpress 2021 Figueres',
    url: 'https://parcsjardins.microdisseny.com/apps/giscube-admin/qgisserver/services/ortoxpres-2021/tilecache/{z}/{x}/{y}.jpg',
    attribution: '&copy; <a href="https://www.icgc.cat/" target="_blank">ICGC</a>',
    maxNativeZoom: 22,
    maxZoom: 23,
    detectRetina: false,
    bounds: [[42.236, 2.927], [42.293, 3.031]]
  }, // {
  //   default: true,
  //   type: 'wms',
  //   name: 'Ortofoto 2020 Aj. Figueres WMS',
  //   url: 'https://parcsjardins.figueres.org/apps/giscube-admin/imageserver/services/ortofoto-2020?',
  //   attribution: '&copy; <a href="https://www.figueres.cat" target="_blank">Ajuntament de Figueres</a>',
  //   maxNativeZoom: 22,
  //   maxZoom: 22,
  //   detectRetina: true,
  //   wmsParams: {
  //     layers: 'ortofoto-2020',
  //     format: 'image/png',
  //     transparent: false
  //   },
  //   bounds: [
  //     [42.237, 2.927],
  //     [42.292, 3.03]
  //   ]
  // },
  {
    default: false,
    type: 'tilelayer',
    name: 'Imatge aèria ICGC',
    url: 'https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.jpeg',
    attribution: '&copy; <a href="https://www.icgc.cat" target="_blank">ICGC</a>',
    maxNativeZoom: 20,
    maxZoom: 22
  }, {
    type: 'tilelayer',
    name: 'Topogràfic ICGC',
    url: 'https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/topo/GRID3857/{z}/{x}/{y}.jpeg',
    attribution: '&copy; <a href="https://www.icgc.cat" target="_blank">ICGC</a>',
    maxNativeZoom: 18,
    maxZoom: 22
  }, {
    default: false,
    type: 'tilelayer',
    name: 'Base ICGC',
    url: 'https://atilemaps.icgc.cat/mapfactory/wmts/topo_suau/CAT3857/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.icgc.cat" target="_blank">ICGC</a>',
    maxNativeZoom: 18,
    maxZoom: 22
  }, {
    type: 'tilelayer',
    name: 'Base ICGC (gris)',
    url: 'https://atilemaps.icgc.cat/mapfactory/wmts/gris_topo_suau/CAT3857/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.icgc.cat" target="_blank">ICGC</a>',
    maxNativeZoom: 18,
    maxZoom: 22
  }, {
    type: 'tilelayer',
    name: 'Base ICGC (nit)',
    url: 'https://btilemaps.icgc.cat/mapfactory/wmts/nit_topo_suau/CAT3857/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.icgc.cat" target="_blank">ICGC</a>',
    maxNativeZoom: 18,
    maxZoom: 22
  }, {
    type: 'tilelayer',
    name: 'Base ICGC (sèpia)',
    url: 'https://btilemaps.icgc.cat/mapfactory/wmts/sepia_topo_suau/CAT3857/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.icgc.cat" target="_blank">ICGC</a>',
    maxNativeZoom: 18,
    maxZoom: 22
  }, {
    default: false,
    type: 'tilelayer',
    name: 'OpenStreetMap',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
    maxNativeZoom: 19,
    maxZoom: 22
  }, {
    default: false,
    type: 'tilelayer',
    name: 'OpenTopoMap',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: 'Map data: &copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
    maxNativeZoom: 19,
    maxZoom: 22
  }, {
    default: false,
    type: 'tilelayer',
    name: 'Stamen TonerLite',
    url: 'https://stamen-tiles-{s}.a.ssl.fastly.net/toner-lite/{z}/{x}/{y}.{ext}',
    attribution: 'Map tiles by <a href="http://stamen.com" target="_blank">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0" target="_blank">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    subdomains: 'abcd',
    minZoom: 0,
    maxNativeZoom: 19,
    maxZoom: 22,
    ext: 'png'
  }, {
    type: 'googleMutant',
    name: 'Roadmap Google',
    options: {
      type: 'roadmap'
    },
    maxNativeZoom: 18,
    maxZoom: 22
  }, {
    type: 'googleMutant',
    name: 'Satellite Google',
    options: {
      type: 'satellite'
    },
    maxNativeZoom: 18,
    maxZoom: 22
  }, {
    type: 'googleMutant',
    name: 'Hybrid Google',
    options: {
      type: 'hybrid'
    },
    maxNativeZoom: 18,
    maxZoom: 22
  }, {
    type: 'googleMutant',
    name: 'Terrain Google',
    options: {
      type: 'terrain'
    },
    maxNativeZoom: 18,
    maxZoom: 22
  }],
  branding: {
    header: {
      logo: require('assets/logo_ajfigueres-negre.svg'),
      text: 'Gesparc',
      link: '#/gesparc'
    }
  },
  capabilities: {
    login: false
  },
  catalog: {
    base: 'https://parcsjardins.figueres.org/apps/giscube-admin/',
    categories: 'https://parcsjardins.figueres.org/apps/giscube-admin/geoportal/category/catalog/',
    search: 'https://parcsjardins.figueres.org/apps/giscube-admin/geoportal/catalog/',
    auth: true
  },
  google: {
    apiKey: 'AIzaSyCLXMu7TKDpM6apI5psRL8du9rnYc_y6uw'
  },
  home: {
    zoom: 15,
    center: {
      lat: 42.266581,
      lng: 2.953937
    }
  },
  locale: {
    main: 'ca',
    fallback: 'en-us'
  },
  searches: [{
    name: 'geoportal',
    title: 'Geoportal search',
    url: 'https://parcsjardins.figueres.org/apps/giscube-admin/geoportal/search/',
    auth: true
  }],
  sentry: {
    dsn: 'https://bd52b9c57503406d89267a30e372539b@o249861.ingest.sentry.io/4505073837539328'
  }
});